import Link from "next/link";
import AppLogo from "@/components/ui/AppLogo";
import Icon from "@/components/ui/AppIcon";

const officeLocations = [
  { label: "Headquarters", city: "Atlanta, Georgia", country: "USA", flag: "🇺🇸" },
  { label: "European Office", city: "Bucharest", country: "Romania", flag: "🇷🇴" },
  { label: "Pacific Office", city: "Sydney", country: "Australia", flag: "🇦🇺" },
  { label: "Asian Office", city: "Singapore", country: "Singapore", flag: "🇸🇬" },
  { label: "North American Ops", city: "Toronto", country: "Canada", flag: "🇨🇦" },
];

export default function Footer() {
  return (
    <footer className="border-t border-[rgba(201,168,76,0.15)] bg-[#0A1628]">
      {/* Security footer strip */}
      <div className="border-b border-[rgba(201,168,76,0.1)] bg-[rgba(201,168,76,0.03)]">
        <div className="max-w-7xl mx-auto px-6 py-5">
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <span className="text-[11px] font-display font-600 uppercase tracking-[0.2em] text-cream/60">
              Protected By
            </span>
            {[
              { icon: "LockClosedIcon", label: "SSL Secured" },
              { icon: "ShieldCheckIcon", label: "Encrypted" },
              { icon: "CheckBadgeIcon", label: "Verified" },
              { icon: "FingerPrintIcon", label: "Privacy Safe" },
              { icon: "KeyIcon", label: "Zero-Knowledge" },
            ].map((badge) => (
              <div key={badge.label} className="flex items-center gap-1.5">
                <Icon name={badge.icon as "LockClosedIcon"} size={14} className="text-gold/80" />
                <span className="text-[12px] font-display font-600 text-cream/65 uppercase tracking-wider">
                  {badge.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Office Locations */}
      <div className="border-b border-[rgba(201,168,76,0.08)] bg-[rgba(255,255,255,0.01)]">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <p className="text-[11px] font-display uppercase tracking-[0.2em] text-gold/80 mb-5 text-center">Global Offices</p>
          <div className="flex flex-wrap items-start justify-center gap-6 md:gap-10">
            {officeLocations.map((office) => (
              <div key={office.label} className="flex items-center gap-2.5 min-w-[140px]">
                <span className="text-lg leading-none">{office.flag}</span>
                <div>
                  <p className="text-[10px] font-display uppercase tracking-widest text-gold/70 mb-0.5">{office.label}</p>
                  <p className="text-[14px] font-body font-500 text-cream/80">{office.city}</p>
                  <p className="text-[12px] font-body font-500 text-cream/55">{office.country}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12 flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo */}
        <Link href="/homepage" className="flex items-center gap-2">
          <AppLogo
            size={28}
            text="StanDave LLC"
            iconName="BuildingOffice2Icon"
            className="text-cream"
          />
        </Link>

        {/* Links */}
        <nav className="flex items-center gap-8">
          <Link
            href="/homepage"
            className="text-[15px] font-display font-600 text-cream/70 hover:text-gold transition-colors uppercase tracking-widest"
          >
            Home
          </Link>
          <Link
            href="/about"
            className="text-[15px] font-display font-600 text-cream/70 hover:text-gold transition-colors uppercase tracking-widest"
          >
            About
          </Link>
          <Link
            href="/homepage#contact"
            className="text-[15px] font-display font-600 text-cream/70 hover:text-gold transition-colors uppercase tracking-widest"
          >
            Contact
          </Link>
        </nav>

        {/* Copyright */}
        <p className="text-[14px] font-body font-500 text-cream/65">
          © 2026 StanDave LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
}